/**
 * Story 16.10 (FR51) — the ONE home of the credit-exhausted action's two
 * constants. Owners (`isOwner()` — superuser folded in, matching
 * `<RequireOwner>` on the target page) get "View billing" to
 * `CREDIT_BILLING_PATH`; members and viewers get `ASK_OWNER_TO_ADD_CREDIT`
 * and no link. Consumers: `CreditBalanceBanner`, `CreditExhaustedAction`
 * (chat turn banner, task-thread banner), `ThreadFailurePost`'s
 * `credit_exhausted` post and the voice credit toast.
 */

/** Usage & credit — where the owner's credit figure, Add credit and history live. */
export const CREDIT_BILLING_PATH = '/admin/observability/usage-llm-cost';

/** What a member or viewer is told instead of a billing link. */
export const ASK_OWNER_TO_ADD_CREDIT = 'Ask your owner to add credit.';
